
<div data-identity="SectionLauncher">
  <cvt-sections
    class="make-scrollable"
    :sections="filteredBlocks"
    :section-tags="tags"
    :loading="loading"
    :active-tag="activeTag"
    :type="$attrs.type"
    :show-add-blank-section="showAddBlankSectionAction"
    :show-add-section="showAddSectionAction"
    @close-section="() => toggleLeftSideMenu({ open: false })"
    @insert-block="(block) => insertBlock(block)"
    @swap-block="(block) => swapBlock(block)"
    @insert-blank="insertBlank"
    @filter-section="(value) => (activeTag = value)"
  />
</div>
